import configDf from './partnersManifest_df.json';
import configProd from './partnersManifest_prod.json';
import { Environment } from '@shared/utils/constants';
import { getWindow } from '@shared/services/window';
const configsMap = {
    [Environment.Production]: configProd,
    [Environment.Canary]: configProd,
    [Environment.Dogfood]: configDf,
    [Environment.Test]: configDf,
    [Environment.Development]: configDf
};
export const loadPartnerManifest = ()=>{
    var _getWindow___INITIAL_STATE___config, _getWindow___INITIAL_STATE__, _getWindow;
    return configsMap[((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow___INITIAL_STATE__ = _getWindow.__INITIAL_STATE__) === null || _getWindow___INITIAL_STATE__ === void 0 ? void 0 : (_getWindow___INITIAL_STATE___config = _getWindow___INITIAL_STATE__.config) === null || _getWindow___INITIAL_STATE___config === void 0 ? void 0 : _getWindow___INITIAL_STATE___config.siteEnvironment) || process.env.siteEnvironment];
};
